import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

export interface PriceListTemplateReportFile {
  Name: string;
  Value: string;
}

@Injectable({
  providedIn: "root",
})
export class PriceListTemplateReportService {
  private readonly baseUrl = "SalesReportService.asmx";

  constructor(private http: HttpUtilService) {}

  printPassengerPriceList(): Observable<HttpResponse<PriceListTemplateReportFile>> {
    const endpoint = `${this.baseUrl}/PrintPassengerPriceList`;
    return this.http.post(endpoint, null);
  }

  printCommercialPriceList(): Observable<HttpResponse<PriceListTemplateReportFile>> {
    const endpoint = `${this.baseUrl}/PrintCommercialPriceList`;
    return this.http.post(endpoint, null);
  }

  printSTAREXFlyerEng(): Observable<HttpResponse<PriceListTemplateReportFile>> {
    const endpoint = `${this.baseUrl}/PrintSTAREXFlyerEng`;
    return this.http.post(endpoint, null);
  }
}
